(() => {
  const DAY = 86400000;

  document.querySelectorAll('[data-yi2c-gift-form]').forEach((form) => {
    const variantId = form.querySelector('[data-yi2c-gift-variant-id]');
    const amount = document.querySelector('[data-yi2c-gift-card-amount]');
    const deliveryInputs = form.querySelectorAll('[name="gift-card-delivery"]');
    const recipientFields = form.querySelector('[data-yi2c-gift-recipient]');
    const control = form.querySelector('[data-yi2c-gift-control]');
    const offset = form.querySelector('[data-yi2c-gift-offset]');
    const managedFields = recipientFields?.querySelectorAll('input, textarea') || [];
    const sendOn = form.querySelector('[data-yi2c-gift-send-on]');

    form.querySelectorAll('[data-yi2c-gift-value]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        variantId.value = input.value;
        if (amount) amount.textContent = input.dataset.amount || '';
      });
    });

    const setRecipientMode = (enabled) => {
      if (!recipientFields || !control) return;
      recipientFields.hidden = !enabled;
      control.disabled = !enabled;
      if (offset) {
        offset.disabled = !enabled;
        offset.value = enabled ? String(new Date().getTimezoneOffset()) : '';
      }
      managedFields.forEach((field) => {
        field.disabled = !enabled;
        if (field.type === 'email') field.required = enabled;
      });
      if (enabled) recipientFields.querySelector('input')?.focus();
    };

    deliveryInputs.forEach((input) => {
      input.addEventListener('change', () => setRecipientMode(input.value === 'recipient' && input.checked));
    });

    if (sendOn) {
      const localDate = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - offset).toISOString().slice(0, 10);
      };
      const today = new Date();
      sendOn.min = localDate(today);
      sendOn.max = localDate(new Date(today.getTime() + (90 * DAY)));
    }
  });
})();
